import { nanoid } from "nanoid";
import { logSentryEvent } from "src/lib/logSentryEvent";

// Temporary partner-webview diagnostics (FEWEB-2806); remove once the cause is found.
export const diagnosticsSessionId = nanoid();

let heartbeatSent = false;

export const sendSessionHeartbeat = (): void => {
  if (heartbeatSent) {
    return;
  }
  heartbeatSent = true;
  logSentryEvent("session heartbeat", { sessionId: diagnosticsSessionId });
};
